<template>
  <div>
    <div v-for="key in sortedConversationItemGroups" :key="key">
      <div class="car-message-date">{{key}}</div>
      <div class="car-message-item" v-for="message in conversationItemsGroupedByDate[key]" :key="message.id">
        <message v-if="message.message" :sender="message.authorId === customer.id" :message="message" />
        <conversation-file-item v-else-if="message.fileType" :item="message" />
      </div>
    </div>
  </div>
</template>

<script>
import Message from './Message';
import _, { each, groupBy, keys } from 'lodash';
import moment from 'moment';
import ConversationFileItem from '@/components/conversation/ConversationFileItem';

export default {
  name: 'MessageList',
  components: {
    ConversationFileItem,
    Message
  },
  computed: {
    threadMessages() {
      return this.$store.getters['conversation/threadMessages'];
    },
    conversationItems() {
      let items = this.threadMessages;
      if (_.get(this, 'thread.attrs.attachedFiles')) {
        items = items.concat(JSON.parse(this.thread.attrs.attachedFiles));
      }
      return items;
    },
    conversationItemsGroupedByDate() {
      let groups = groupBy(this.conversationItems, message => moment(message.createdAt).format('L'));
      each(groups, (group, index) => {
        group = group.sort((a, b) => moment(a.createdAt).valueOf() - moment(b.createdAt).valueOf())
      });
      return groups;
    },
    sortedConversationItemGroups() {
      return keys(this.conversationItemsGroupedByDate).sort((a, b) => moment(a, 'L').valueOf() - moment(b, 'L').valueOf());
    },
    thread() {
      return this.$store.getters['conversation/thread'];
    },
    customer() {
      if (!this.thread.participants[0].locationId) {
        return this.thread.participants[0];
      } else {
        return this.thread.participants[1];
      }
    }
  },
  mounted() {
    var textElms = document.getElementsByClassName('talktext');
    if (textElms[textElms.length - 1]) textElms[textElms.length - 1].scrollIntoView();
  }
}
</script>
